import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/ming-chuang'

export async function tags() {
    return request(api.tags.url)
}

export async function memberInfo(params) {
    return request(`${api.memberInfo.url}${stringify(params, {addQueryPrefix: true})}`)
}
